import { convertDurationToMinutes } from '@/shared/lib'
import { Box, Typography } from '@mui/material'
import React from 'react'

interface Props {
    year?: number | string
    genres?: string[]
    country?: string
    duration?: number | null
}
const FilmOverviewInfos = ({ year, genres, country, duration }: Props) => {
    const infoContainerStyle = {
        position: 'relative',
        zIndex: 1,
        display: 'flex',
        typography: 'text1',
        gap: '20px',
    }

    return (
        <Box sx={infoContainerStyle}>
            {year && <Typography>{year}</Typography>}
            {year && '|'}
            {genres && <Typography>{genres}</Typography>}
            {genres && '|'}
            {country && <Typography>{country}</Typography>}
            {country && '|'}
            {duration && (
                <Typography>{convertDurationToMinutes(duration)}</Typography>
            )}
        </Box>
    )
}

export default FilmOverviewInfos
